module.exports = __webpack_public_path__ + "img/login.cc6a2559.jpg";